import { PageId } from 'constants/pages'

export const enum PageIdWoofzPupBl {
  DOG_AGE_PUP_BL = PageId.DOG_AGE_PUP_BL,
  DOG_OWNER_PUP_BL = PageId.DOG_OWNER_PUP_BL,
  TRAINING_COMMANDS_PUP_BL = PageId.TRAINING_COMMANDS_PUP_BL,
  URGE_PAGE_PUP_BL = PageId.URGE_PAGE_PUP_BL,
  DOG_BREED_PUP_BL = PageId.DOG_BREED_PUP_BL,
  FACING_CHALLENGES_PUP_BL = PageId.FACING_CHALLENGES_PUP_BL,
  FACING_CHALLENGES_2_PUP_BL = PageId.FACING_CHALLENGES_2_PUP_BL,
  BEHAVIOR_FREQUENCY_PUP_BL = PageId.BEHAVIOR_FREQUENCY_PUP_BL,
  URGE_PROGRAM_PUP_BL = PageId.URGE_PROGRAM_PUP_BL,
  BEHAVIOR_FEELINGS_PUP_BL = PageId.BEHAVIOR_FEELINGS_PUP_BL,
  FIX_BEHAVIOR_PUP_BL = PageId.FIX_BEHAVIOR_PUP_BL,
  URGE_PAGE_4_PUP_BL = PageId.URGE_PAGE_4_PUP_BL,
  COMMANDS_PUP_BL = PageId.COMMANDS_PUP_BL,
  PARENT_GOAL_PUP_BL = PageId.PARENT_GOAL_PUP_BL,
  TRAINING_PLACE_PUP_BL = PageId.TRAINING_PLACE_PUP_BL,
  TRAINING_FREQUENCY_PUP_BL = PageId.TRAINING_FREQUENCY_PUP_BL,
  URGE_PAGE_5_PUP_BL = PageId.URGE_PAGE_5_PUP_BL,
  PREPARE_FLOW_PUP_BL = PageId.PREPARE_FLOW_PUP_BL,
  EMAIL_PUP_BL = PageId.EMAIL_PUP_BL,
  NEWSLETTER_URGE_PUP_BL = PageId.NEWSLETTER_URGE_PUP_BL,
  LAST_CHANCE_OFFER_PUP_BL = PageId.LAST_CHANCE_OFFER_PUP_BL,
  SUBSCRIPTIONS_PUP_BL = PageId.SUBSCRIPTIONS_PUP_BL,
  CHAT_UPSELL_PUP_BL = PageId.CHAT_UPSELL_PUP_BL,
  UPSELL_PUP_BL = PageId.UPSELL_PUP_BL,
  UPSELL_FEEDING_GUIDE_PUP_BL = PageId.UPSELL_FEEDING_GUIDE_PUP_BL,
  UPSELL_EMOTIONAL_SUPPORT_PUP_BL = PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_BL,
  DOWNLOAD_PUP_BL = PageId.DOWNLOAD_PUP_BL,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
